// !!!!!!! COMMENTS ARE FOR V2 DO NOT DELETE THEM !!!!!!!!!!!
// !!!!!!! COMMENTS ARE FOR V2 DO NOT DELETE THEM !!!!!!!!!!!
// !!!!!!! COMMENTS ARE FOR V2 DO NOT DELETE THEM !!!!!!!!!!!
import { Component } from 'react'
import { Manager, Reference, Popper } from 'react-popper'
import TooltipBox from '../TooltipBox'
import HoverDelay from '../../utils/HoverDelay'
import Portal from '../../utils/Portal'
import { Text, Box } from 'rebass'
import Subtitle from '../titles/Subtitle'
import { Observer, observer, useLocalObservable } from 'mobx-react-lite'

const Day = observer(({ day, modifiers, modifiersMap }) => {
  const state = useLocalObservable(() => ({
    hovering: false
  }))

  const date = day.getDate()
  // const modifiers = props.modifiers

  const bodyModifier = modifiersPriority(modifiers, 'body')
  const titleModifier = modifiersPriority(modifiers, 'title')

  return (
    <Manager>
      <Reference>
        {({ ref }) => (
          <HoverDelay onMouseOver={hover} onMouseOut={unHover} delay={300}>
            <div>
              {/* <Box p={'5px'} ref={ref} fontSize={['l', 'xxs']}> */}
              <Box p={'5px'} ref={ref} fontSize={'xxs'}>
                {date}
              </Box>
            </div>
          </HoverDelay>
        )}
      </Reference>
      <Popper
        placement='bottom-start'
        modifiers={{
          preventOverflow: {
            boundariesElement: 'document.body'
          },
          offset: { offset: '0 ,5px' }
        }}>
        {({ ref, style, placement, arrowProps }) => (
          <Portal selector='body'>
            <Observer>
              {() =>
                !!state.hovering && (
                  <div ref={ref} style={{ zIndex: 102, ...style }} data-placement={placement}>
                    {!!titleModifier && (
                      <TooltipBox>
                        <Subtitle textAlign='left'>{titleModifier}</Subtitle>
                        {!!bodyModifier && <Text fontSize={[12]}>{bodyModifier}</Text>}
                      </TooltipBox>
                    )}
                    <div ref={arrowProps.ref} style={arrowProps.style} />
                  </div>
                )
              }
            </Observer>
          </Portal>
        )}
      </Popper>
    </Manager>
  )

  function hover () {
    if (!state.hovering) {
      state.hovering = true
    }
  }
  function unHover () {
    state.hovering = false
  }

  function modifiersPriority (modifiers, field) {
    if (modifiers.past) {
      return modifiersMap.past[field]
    } else if (modifiers.notOpenYet) {
      return modifiersMap.notOpenYet[field]
    } else if (modifiers.notOpenAnymore) {
      return modifiersMap.notOpenAnymore[field]
    } else if (modifiers.waitlistOpen) {
      return modifiersMap.waitlistOpen[field]
    } else if (modifiers.closed) {
      return modifiersMap.closed[field]
    } else if (modifiers.full) {
      return modifiersMap.full[field]
    } else if (modifiers.fullPax) {
      return modifiersMap.fullPax[field]
    } else if (modifiers.fullCommands) {
      return modifiersMap.fullCommands[field]
    }
  }
})

export default Day
